import { Dispatch, SetStateAction, useEffect } from 'react';

import { isUndefined } from 'lodash';
import {
    copyCoreRatesTo3PGrid,
    copyDiscountCapsTo3PGrid,
    copyMultipliersTo1PGrid,
    copyMultipliersTo3PGrid
} from 'src/components/RateCardDetail/mappers/grid-content';
import { IMetadata } from 'src/types/IMetadata';
import { IFirstPartyCorePlan, IMultiplierType, IRateCardValues } from 'src/types/IRateCard';

/**
 * Syncs data across the rate card detail screens
 */
export function useRateCardDetail(
    rateCardValues: IRateCardValues,
    setRateCardValues: Dispatch<SetStateAction<IRateCardValues>>,
    multiplierTypeList: IMultiplierType[],
    thirdPartyPlanList: Record<string, string | boolean | number>[],
    corePlanList: IFirstPartyCorePlan[],
    metadata: IMetadata,
    isEditMode: boolean
) {
    if (!isEditMode) {
        return;
    }

    useEffect(() => {
        if (!isUndefined(metadata.regionMapping)) {
            copyCoreRatesTo3PGrid(
                rateCardValues,
                setRateCardValues,
                multiplierTypeList,
                thirdPartyPlanList,
                corePlanList,
                metadata.territoryMapping,
                metadata.regionMapping
            );
        }
    }, [
        // this is needed to ensure core rate edits trigger updates
        JSON.stringify(rateCardValues.coreRates),
        metadata
    ]);

    useEffect(() => {
        copyDiscountCapsTo3PGrid(rateCardValues, setRateCardValues);
    }, [rateCardValues.contractTerms?.thirdPartyDeductionCaps]);

    useEffect(() => {
        copyMultipliersTo1PGrid(rateCardValues, setRateCardValues, multiplierTypeList);
        copyMultipliersTo3PGrid(rateCardValues, setRateCardValues, multiplierTypeList);
    }, [rateCardValues.contractTerms?.rateMultipliers]);
}
